module.exports = __webpack_public_path__ + "static/img/novikorisnik1.22d59e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/novikorisnik1.png
// module id = r/d4
// module chunks = 0